import { useQuery } from 'data-fetching-client';
import I18n from 'I18n';
import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import uniqueIdForObject from 'automation-ui-core/utils/uniqueIdForObject';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { GET_FILTER_BRANCH_DESCRIPTION } from 'automation-ui-action-features/queries/filterBranchDescriptionQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListBranchActionSummary({
  action,
  flowObjectTypeId
}) {
  const connection = action.getConnection();
  const branches = connection.getBranches();
  const firstBranch = branches.get(0);
  const firstBranchFilter = firstBranch.getFilterBranch();
  const shouldUseBranchDescription = branches.size === 1 && firstBranchFilter;
  const {
    loading,
    data: {
      filterDescription = ''
    } = {}
  } = useQuery(GET_FILTER_BRANCH_DESCRIPTION, {
    skip: !shouldUseBranchDescription,
    variables: {
      objectTypeId: flowObjectTypeId,
      filterBranch: firstBranchFilter,
      uniqueId: uniqueIdForObject(firstBranchFilter)
    }
  });
  const defaultBranchName = connection.getDefaultBranchName() || I18n.text('automation-ui-action-features.action-features.list-branch.branch-name.otherwiseConditionDefault');
  const branchNames = branches.map((branch, index) => branch.getBranchName() || I18n.text('automation-ui-action-features.action-features.list-branch.branch-name.default', {
    branchNumber: index + 1
  })).toArray();
  branchNames.push(defaultBranchName);
  if (shouldUseBranchDescription && (!!filterDescription || loading)) {
    const [firstBranchName] = branchNames;
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.list-branch.summary-with-one-branch",
      options: {
        branchName: /*#__PURE__*/_jsx("strong", {
          children: firstBranchName
        }),
        defaultBranchName: /*#__PURE__*/_jsx("strong", {
          children: defaultBranchName
        }),
        conditions: loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsx("strong", {
          children: filterDescription
        })
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.list-branch.summary",
      options: {
        branches: /*#__PURE__*/_jsx(FormattedList, {
          children: branchNames.map((branchName, index) => /*#__PURE__*/_jsx("strong", {
            children: branchName
          }, index))
        })
      }
    });
  }
}